import { useEffect } from 'react';

import { useEnums } from './useEnums';
import { useKeyPorts } from './useKeyPorts';

export const usePrefetchQueries = () => {
    const { prefetch: prefetchKeyPorts } = useKeyPorts();
    const { prefetch: prefetchEnums } = useEnums();

    useEffect(() => {
        prefetchKeyPorts();
        prefetchEnums();
    }, [prefetchEnums, prefetchKeyPorts]);
};
